import { createRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { rootRoute } from './__root';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';
import { PermissionGate } from '@/components/admin/permission-gate';
import { AdminSubNav } from '@/components/admin/admin-sub-nav';
import { CapacityBar } from '@/components/admin/capacity-bar';

export const adminObservabilityCapacityRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/admin/observability/capacity',
  component: AdminObservabilityCapacityPage,
});

function AdminObservabilityCapacityPage() {
  return (
    <PermissionGate permission="platform:observe">
      <Capacity />
    </PermissionGate>
  );
}

function Capacity() {
  const capacityQuery = useQuery({
    queryKey: queryKeys.admin.capacity(),
    refetchInterval: 30_000,
    queryFn: async () => {
      const { data, error } = await apiClient.GET('/admin/observability/capacity');
      if (error) throw error;
      return data;
    },
  });

  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-2xl font-semibold">Capacity</h1>
      <AdminSubNav active="capacity" />
      {capacityQuery.isLoading && (
        <p className="text-sm text-muted-foreground">Loading capacity…</p>
      )}
      {capacityQuery.isError && (
        <p className="text-sm text-red-600">Failed to load capacity.</p>
      )}
      {capacityQuery.data && (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {capacityQuery.data.resources.map((r) => (
            <CapacityBar key={r.name} resource={r} />
          ))}
        </div>
      )}
    </div>
  );
}
